// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"96":"b88e31f9","97":"68c1ed9d","224":"7019f8ef","262":"6fd62bf4","268":"406c0820","330":"75de2f58","392":"826104d2","401":"6bb7705a","421":"b90771bc","568":"fe138e69","571":"1a20faaf","591":"1641439f","697":"e77f2fda","737":"276fc7b2","844":"20b46090"}[chunkId] + ".js";
};